import {useTheme} from '#/alf'
import {type Props} from '#/components/icons/common'
import {VerifiedCheck} from '#/components/icons/VerifiedCheck'
import {VerifierCheck} from '#/components/icons/VerifierCheck'

export function VerificationCheck({
  verifier,
  ...rest
}: Props & {
  verifier?: boolean
}) {
  const t = useTheme()
  return verifier ? (
    <VerifierCheck {...rest} fill={t.palette.primary_500} />
  ) : (
    <VerifiedCheck {...rest} fill={t.palette.primary_500} />
  )
}
